
import { ref } from "vue"
import { useI18n } from "vue-i18n/index";
import {
    errManager
} from "@/core/config/Tools";
import axios from "axios";

export default {
    name: "btnDownload",
    props: {
        /*color: {
            type: String,
            required: false,
            default: "#626aef",
        },*/
        nameFile: {
            type: String,
            required: true,
            default: ""
        },
        resource: {
            type: String,
            required: true,
            default: ""
        }
    },
    setup(props) {
        const { t } = useI18n();
        const loaderDown = ref(false);
        const url = ref(process.env.VUE_APP_REPO);

        const DownloadFile = () => {
            loaderDown.value = true;
            axios({
                url: url.value + `/uploads/${props.resource}`,
                method: "GET",
                responseType: "blob",
            })
                .then((response) => {
                    loaderDown.value = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fURL = document.createElement("a");
                    var nameFile = props.nameFile + ".jpg";

                    fURL.href = fileURL;
                    fURL.setAttribute("download", nameFile);
                    document.body.appendChild(fURL);
                    fURL.click();
                })
                .catch(({
                    response
                }) => {
                    loaderDown.value = false;
                    errManager(response, null, 2);
                });
        };

        return {
            t,
            url,
            loaderDown,
            DownloadFile
        }

    },
}
